'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$187(ps$95) {
  this.a72 = null;
  this.a72 = ps$95;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$187 as $c_Lmealorama_jsonCodecs$package$$anon$187 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$187.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$187;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$187() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$187 as $h_Lmealorama_jsonCodecs$package$$anon$187 };
$h_Lmealorama_jsonCodecs$package$$anon$187.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a72.a.length;
});
$p.g = (function(i) {
  return this.a72.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$187 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$187, "mealorama.jsonCodecs$package$$anon$187", ({
  JE: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$187 as $d_Lmealorama_jsonCodecs$package$$anon$187 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$187.js.map
